export enum AddressActionKeys {
  SET_ADDRESSES = 'SET_ADDRESSES',
  TOGGLE_ADDRESS_SAVING = 'TOGGLE_ADDRESS_SAVING',
  UPDATE_ADDRESS_FROM_AX_ADDRESS = 'UPDATE_ADDRESS_FROM_AX_ADDRESS'
}
